import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const ConfirmationModal = ({
  action,
  actionType,
  isOpen,
  toggle,
  title = "",
  isClosure = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={isClosure ? "lg" : "sm"}
      centered
    >
      <ModalHeader className="border-0" toggle={toggle}>
        {isClosure &&
          "Please confirm that the incident is ready for closure and that closure tasks can be assigned for completion."}
      </ModalHeader>
      <ModalBody className="pt-0">
        {isClosure ? (
          <p>
            A task will be assigned to the Local and Senior Incident Managers
            requesting completion of the final comment boxes. Once completed, a
            final task will be assigned to the Incident Manager to add any final
            comments and finalise closure. NOTE: H&S incidents with a RAG status
            of Green/Amber will require a final comment from the Local Incident
            Manager ONLY.
          </p>
        ) : (
          <h6>
            Are you sure you wish to {`${actionType}`} this {`${title}`}?
          </h6>
        )}
        <div className="row">
          <div className="col-6">
            <button
              type="button"
              className="btn w-100 btn-green"
              onClick={action}
            >
              Yes
            </button>
          </div>
          <div className="col-6">
            <button
              type="reset"
              className="btn w-100 btn-grey"
              onClick={toggle}
            >
              No
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
